<template>
  <main class="home" @wheel="scrollWheel($event)" v-touch:swipe.left="slideLeft" v-touch:swipe.right="slideRight" v-touch:swipe.down="slideLeft" v-touch:swipe.up="slideRight">
    <section class="content">
      <div class="content__title" @click="openProject()">
        <div class="title__number"><div>0{{i+1}}</div></div>
        <h1 class="title">
          <p class="title__first__line">{{cutTitle(".title__first__line", works[i].title[0])}}</p>
          <p class="title__second__line" v-if="works[i].title[1]">
          {{cutTitle(".title__second__line", works[i].title[1])}}</p>
        </h1>
      </div>
      <div class="scene__hotspot" @click="openProject()"></div>
      <div class="subtitle date">{{works[i].year}}</div>
      <div class="subtitle type">{{works[i].type}}</div>
    </section>
    <footer class="footer">
      <div class="slider">
        <div class="slide"><div class="circle active" @click="slider(0, $event)"></div></div>
        <div class="slide"><div class="circle" @click="slider(1, $event)"></div></div>
        <div class="slide"><div class="circle" @click="slider(2, $event)"></div></div>
        <div class="slide"><div class="circle" @click="slider(3, $event)"></div></div>
        <div class="slide"><div class="circle" @click="slider(4, $event)"></div></div>
      </div>
      <div class="socials">
        <a href="https://twitter.com/Theo_grand1" rel="noreferrer" target="_blank" class="paragraph">twitter</a>
        <a href="https://dribbble.com/Theo_Grandin" rel="noreferrer" target="_blank" class="paragraph">dribbble</a>
        <a href="https://www.linkedin.com/in/theo-grandin/" rel="noreferrer" target="_blank" class="paragraph">linkedin</a>
        <label class="paragraph" @click="copy" for="mailCopy">
          email
          <span class="mailCTA">Click to copy mail to clipboard</span>
        </label>
      </div>
    </footer>
    <textarea id="mailCopy" readonly></textarea>
  </main>
</template>

<script>
import Vue from 'vue'
import Works from '@/assets/js/works.json'
import Vue2TouchEvents from 'vue2-touch-events'
const Lethargy = require('@/assets/js/lethargy.min.js')
let lethargy = new Lethargy.Lethargy()
Vue.use(Vue2TouchEvents)

export default {
  name: 'home',
  data () {
    return {
      i: 0,
      works: Works,
      timer: true,
      sceneHeight: 0,
      lineHeight: 0
    }
  },

  mounted () {
    this.sceneHeight = document.querySelector('.scene').offsetHeight + 5
    if (this.$parent.fromProject) {
      this.enterFromProject()
    } else if (this.$parent.load === false) {
      if (this.$parent.fromChapter === true) {
        let previous = (this.$parent.i + 4) % 5
        let imgContainer = document.querySelector('.scene')
        this.$parent.videos[previous].style.opacity = '0'
        this.enterFromProject()
        this.timer = false
        imgContainer.style.transition = 'width 1s cubic-bezier(0.86,-0.06, 0.23, 0.99)'
        setTimeout(() => { this.timer = true }, 1500)
      }
      this.transitionEnter('forward')
      this.$parent.videos[this.$parent.i].style.opacity = '0'
      this.$parent.videos[this.i].style.opacity = '1'
      this.$parent.videos[this.i].play()
    }

    window.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        let slide = document.querySelectorAll('.slide .circle')
        let nextNumber = (this.i + 4) % 5
        slide[nextNumber].click()
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        let slide = document.querySelectorAll('.slide .circle')
        let nextNumber = (this.i + 1) % 5
        slide[nextNumber].click()
      }
    })

    window.addEventListener('resize', () => {
      this.sceneHeight = window.innerHeight / 1.5 + 5
    })
  },

  methods: {
    slider (slideNumber, event) {
      if (slideNumber !== this.i) {
        let side = ''
        if (slideNumber > this.i) {
          side = 'forward'
        } else {
          side = 'backward'
        }
        this.transitionLeave(false, side)
        document.querySelector('.circle.active').classList.remove('active')
        event.target.classList.add('active')
        // switch slide
        setTimeout(() => {
          this.cleanTitle()
          this.$parent.videos[this.i].pause()
          this.$parent.videos[this.i].style.opacity = '0'
          this.i = slideNumber
          this.$parent.videos[this.i].play()
          this.$parent.videos[this.i].style.opacity = '1'
          this.transitionEnter(side)
        }, 1300)
      }
    },

    cutTitle (className, title) {
      this.$nextTick(() => {
        let children
        for (let i = 0; i < title.length; i += 1) {
          const span = document.createElement('span')
          if (title[i] === ' ') {
            children = '\u00A0'
          } else {
            children = title[i]
          }
          span.style.display = 'inline-block'
          span.append(children)
          document.querySelector(className).append(span)
        }
        this.lineHeight = document.querySelector('.title__first__line').clientHeight + 10
        this.transitionTitleEnter(className)
      })
    },

    cleanTitle () {
      document.querySelector('.title__first__line').innerHTML = ''
      if (document.querySelector('.title__second__line')) document.querySelector('.title__second__line').innerHTML = ''
    },

    copy () {
      const text = document.querySelector('textarea')
      const mailCTA = document.querySelector('.mailCTA')
      text.value = 'theo.grandin74@gmail.com'
      text.select()
      document.execCommand('copy')
      mailCTA.innerHTML = 'Copied!'
    },

    transitionTitleEnter (className) {
      let spans = document.querySelectorAll(className + ' span')
      for (let i = 0; i < spans.length; i++) {
        spans[i].style.transform = 'translateY(' + this.lineHeight + 'px)'
      }

      setTimeout(() => {
        for (let i = 0; i < spans.length; i++) {
          spans[i].style.transition = 'all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99)'
          spans[i].style.transitionDelay = 0.03 * i + 's'
          spans[i].style.transform = 'translateY(0px)'
        }
      }, 50)
    },

    transitionTitleLeave (className) {
      let spans = document.querySelectorAll(className + ' span')
      for (let i = 0; i < spans.length; i++) {
        spans[i].style.transitionDelay = 0.03 * i + 's'
        spans[i].style.transform = 'translateY(' + this.lineHeight + 'px)'
      }
    },

    transitionEnter (side) {
      let slide = document.querySelector('.scene__slide')

      slide.style.transition = 'all 0s'
      if (side === 'forward') {
        slide.style.transform = 'translateX(' + this.sceneHeight + 'px)'
      } else {
        slide.style.transform = 'translateX(-' + this.sceneHeight + 'px)'
      }

      this.subtitleNumberAnimation()
      setTimeout(() => {
        slide.style.transition = 'transform 1.15s cubic-bezier(0.86,-0.06, 0.23, 0.99)'
        slide.style.transform = 'translateX(0px)'
      }, 50)
    },

    transitionLeave (leave, side) {
      // get div for animations
      let number = document.querySelector('.title__number div')
      let subtitle = document.querySelectorAll('.subtitle')
      let slide = document.querySelector('.scene__slide')

      // animations
      number.style.transform = 'translateY(100px)'
      for (let i = 0; i < subtitle.length; i++) {
        subtitle[i].style.opacity = '0'
      }
      this.transitionTitleLeave('.title__first__line')
      this.transitionTitleLeave('.title__second__line')
      if (leave === false) {
        if (side === 'forward') {
          slide.style.transform = 'translateX(-' + this.sceneHeight + 'px)'
        } else {
          slide.style.transform = 'translateX(' + this.sceneHeight + 'px)'
        }
      }
    },

    subtitleNumberAnimation () {
      let number = document.querySelector('.title__number div')
      let subtitle = document.querySelectorAll('.subtitle')
      setTimeout(() => {
        number.style.transform = 'translateY(0px)'
        for (let i = 0; i < subtitle.length; i++) {
          subtitle[i].style.opacity = '0.4'
        }
      }, 50)
    },

    enterFromProject () {
      let slideActive = document.querySelector('.slide .circle.active')
      let slides = document.querySelectorAll('.slide .circle')
      this.i = ''
      this.i = this.$parent.i
      slideActive.classList.remove('active')
      slides[this.i].classList.add('active')
      this.$nextTick(() => {
        this.cleanTitle()
        this.subtitleNumberAnimation()
      })
    },

    timerValue () {
      let timer

      // calculate transitions duration
      if (document.querySelector('.title__second__line')) {
        timer = (document.querySelectorAll('.title__second__line span').length - 1) * 0.03 + 1
      } else {
        timer = (document.querySelectorAll('.title__first__line span').length - 1) * 0.03 + 1
      }
      return timer
    },

    openProject () {
      this.transitionLeave(true)

      let footer = document.querySelector('.footer')
      let timer = this.timerValue()
      footer.style.opacity = '0'

      setTimeout(() => {
        this.$router.push('/project/' + this.i)
      }, timer * 1000)
    },

    scrollWheel (e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.timer === true && lethargy.check(e) !== false) {
        this.timer = false
        let slide = document.querySelectorAll('.slide .circle')
        if (lethargy.check(e) === -1) {
          let nextNumber = (this.i + 1) % 5
          slide[nextNumber].click()
        } else {
          let nextNumber = (this.i + 4) % 5
          slide[nextNumber].click()
        }
        setTimeout(() => { this.timer = true }, 2000)
      }
    },

    slideLeft () {
      let slide = document.querySelectorAll('.slide .circle')
      let nextNumber = (this.i + 1) % 5
      slide[nextNumber].click()
    },

    slideRight () {
      let slide = document.querySelectorAll('.slide .circle')
      let nextNumber = (this.i + 4) % 5
      slide[nextNumber].click()
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'About') {
      this.transitionLeave(false, 'forward')
      document.querySelector('.slider').style.opacity = 0
      setTimeout(() => {
        this.$parent.videos[this.i].style.opacity = '0'
        next()
      }, 1300)
    } else {
      next()
    }
  }
}

</script>

<style lang="scss" scoped>

// responsive
$phone:640px;
$tablet: 768px;
$desktop: 1024px;
$large: 1680px;

.home
{
  width: 100vw;
  height:100vh;
  position: relative;
  display: grid;
  grid-template-rows:32px 1fr calc(100vh / 1.5) 1fr 32px;
  z-index: 2;

    @media screen and (max-width: $phone) and (orientation: portrait) {
      grid-template-rows: 32px 0.9fr calc(100vw - 80px) 1.1fr 32px;
      position: fixed;
      height: 100%;
    }

  .content
  {
    display: grid;
    grid-template-columns:1fr 16px calc(100vh / 1.5) 16px 1fr;
    grid-row-start: 3;
    grid-row-end: 4;
    position: relative;

    @media screen and (max-width: $phone) and (orientation: portrait) {
      grid-template-columns: 1fr 4px calc(100vw - 80px) 4px 1fr;
    }

    .content__title
    {
      grid-column-start: 1;
      grid-column-end: 4;
      grid-row-start:1;
      display: flex;
      margin-top: calc(100vh/6);
      margin-left: calc(100vw / 5);
      position: absolute;
      z-index: 2;
      cursor: pointer;

      @media screen and (max-width: $phone) and (orientation: portrait) {
        margin-top: 13%;
        margin-left: 16px;
      }

      .title
      {
        line-height: 92px;
        align-self:flex-start;

        @media screen and (min-width:$large){
          line-height: 112px;
        }

        .title__second__line
        {
          margin-top: 22px;

          @media screen and (max-width: $phone) {
            margin-top: 0px;
          }
        }

        .title__first__line, .title__second__line
        {
          overflow: hidden;
        }

        @media screen and (max-width: $phone) {
          line-height: 1;
        }
      }

      .title__number
      {
        font-family: "DIN Pro";
        font-size: 18px;
        color: rgba(255,255,255,0.40);
        margin-right: 8px;
        align-self: flex-start;
        overflow: hidden;

        div
        {
          transform: translateY(100px);
          transition: all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);
        }

        @media screen and (max-width: $phone) {
          display: none;
        }
      }
    }

    .type
    {
      grid-column-start: 5;
      grid-row-start: 1;
      position:absolute;
      left: 0;
      top: calc(100vh / 15);
      transform: rotate(90deg);
      transform-origin: bottom left;
      transition: all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);

      @media screen and (max-width: $phone) {
        top: calc((100vw - 80px) / 10);
      }
    }

    .date
    {
      grid-column-start: 1;
      grid-column-end: 2;
      grid-row-start: 1;
      position:absolute;
      right: 0;
      bottom: calc(100vh / 15 + 38px);
      transform: rotate(-90deg);
      transform-origin: bottom right;
      transition: all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);

      @media screen and (max-width: $phone) {
        font-size: 12px;
        bottom: calc(((100vw - 80px) / 10) + 26px);
      }
    }

    .scene__hotspot
    {
      grid-column-start: 3;
      grid-column-end: 4;
      cursor: pointer;
    }
  }

  .subtitle
  {
    opacity: 0;
  }
}

</style>

<style lang="scss">
// responsive
$phone:640px;
$tablet: 768px;
$desktop: 1024px;

.footer
{
  grid-row-start: 4;
  grid-row-end: 5;
  width:calc(100vw - 140px);
  margin:0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  transition: all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);

  @media screen and (max-width:$phone) and (orientation: portrait) {
    width:calc(100vw - 48px);
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr;
  }

  .slider
  {
    width: 104px;
    height: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);

    @media screen and (max-width:$phone) and (orientation: portrait) {
      margin: 0 auto;
      width: 150px;
    }

    .slide
    {
      width: 8px;
      display: flex;
      justify-content: center;

      @media screen and (max-width:$phone) and (orientation: portrait) {
        width: 12px;
      }

      .circle
      {
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: #fff;
        opacity: 0.2;
        cursor: pointer;
        transition:0.4s cubic-bezier(0.63, 0.01, 0.11, 0.98);

        @media screen and (max-width:$phone) and (orientation: portrait) {
          width: 12px;
          height: 12px;
          border-radius: 6px;
        }

        &:hover
        {
          opacity: 0.7;
        }
      }

      .active
      {
        width: 10px;
        height: 10px;
        border-radius: 7px;
        border: 1px #fff solid;
        background-color: initial;
        opacity: 0.7;
        flex-shrink: 0;
      }
    }
  }

  .socials
  {
    display: flex;

    @media screen and (max-width:$phone) and (orientation: portrait) {
      grid-row-start: 2;
      justify-content: space-between;
    }

    .paragraph
    {
      margin-right: 40px;
      opacity: 0.2;
      transition:0.4s ease;
      position: relative;

      @media screen and (max-width:$phone) and (orientation: portrait) {
        margin: 0;
        grid-row-start: 2;
        justify-content: space-between;
      }

      .mailCTA
      {
        width:300px;
        text-align:right;
        position:absolute;
        top: -32px;
        right:0px;
        opacity:0;
        transition:0.4s ease;
      }

      &:last-child
      {
        margin-right: 0px;
        cursor: pointer;

        &:hover
        {
          .mailCTA
          {
            opacity:1;
          }

        }
      }

      &:hover
      {
        opacity: 0.6;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue